import { mapResponsivePropToStyles, mergeResponsivePropsToStyles, mergeStyles, } from '@coolblue-development/freddy';
const ImageSizes = {
    small: { imageHeight: 100, imageWidth: 187 },
    medium: { imageHeight: 170, imageWidth: 318 },
};
export const getImageSizeStyle = (size = 'medium') => {
    return ImageSizes[size];
};
const imageSizesByRem = {
    small: '10rem',
    medium: '17rem',
};
const labelsPositionOnBreakpoints = {
    top: 'absolute',
    middle: 'absolute',
    bottom: 'absolute',
    belowImage: 'relative',
};
const labelsPositionJustifyContent = {
    top: 'flex-start',
    middle: 'center',
    bottom: 'flex-end',
    belowImage: 'flex-start',
};
export const getWideProductImageStyles = ({ labelsPosition, size, theme, }) => mergeStyles([
    {
        width: '100%',
        height: '100%',
        '& img': {
            display: 'inline-block',
            verticalAlign: 'middle',
            paddingBottom: theme.spacing[200],
        },
    },
    getContainerPadding({ labelsPositionValue: labelsPosition, sizeValue: size, theme }),
    getContainerHeightFromSize({ sizeValue: size }),
]);
export const getLabelsStyles = ({ size, labelsPosition, theme, }) => mergeStyles([
    {
        top: 0,
        padding: size === 'small' ? `${theme.spacing[200]} 0` : `${theme.spacing[400]} 0`,
        ...(labelsPosition === 'top' && {
            justifyContent: 'flex-start',
        }),
        ...(labelsPosition === 'middle' && {
            justifyContent: 'center',
        }),
        ...(labelsPosition === 'bottom' && {
            justifyContent: 'flex-end',
        }),
    },
    getContainerHeightFromSize({ sizeValue: size }),
    getLabelsPositionBreakpoints({ labelsPositionValue: labelsPosition, sizeValue: size, theme }),
]);
const getContainerHeightFromSize = ({ sizeValue, }) => {
    const resolveSize = (size) => ({
        height: imageSizesByRem[size],
        maxHeight: imageSizesByRem[size],
    });
    return mapResponsivePropToStyles(sizeValue, resolveSize);
};
const getContainerPadding = ({ labelsPositionValue, sizeValue, theme, }) => {
    const resolvePadding = ({ labelsPosition, size, }) => ({
        padding: labelsPosition === 'belowImage'
            ? `0 ${theme.spacing[100]}`
            : `0 ${theme.spacing[size === 'small' ? 400 : 600]}`,
    });
    return mergeResponsivePropsToStyles({ labelsPosition: labelsPositionValue, size: sizeValue }, resolvePadding);
};
const getLabelsContainerHeight = ({ size, labelsPosition, }) => {
    if (labelsPosition === 'belowImage') {
        return 'auto';
    }
    return imageSizesByRem[size];
};
const getLabelsContainerPadding = ({ labelsPosition, theme, }) => {
    if (labelsPosition === 'belowImage') {
        return `0 0 ${theme.spacing[200]} 0`;
    }
    return `${theme.spacing[200]} 0`;
};
const getLabelsPositionBreakpoints = ({ sizeValue, labelsPositionValue, theme, }) => {
    const resolveLabelsPosition = ({ labelsPosition, size, }) => ({
        position: labelsPositionOnBreakpoints[labelsPosition],
        justifyContent: labelsPositionJustifyContent[labelsPosition],
        height: getLabelsContainerHeight({ size, labelsPosition }),
        padding: getLabelsContainerPadding({ labelsPosition, theme }),
    });
    return mergeResponsivePropsToStyles({ labelsPosition: labelsPositionValue, size: sizeValue }, resolveLabelsPosition);
};
//# sourceMappingURL=WideProductImage.styles.js.map